import { render, staticRenderFns } from "./StoreCustomer.vue?vue&type=template&id=a05d2d1c&scoped=true&"
import script from "./StoreCustomer.vue?vue&type=script&lang=js&"
export * from "./StoreCustomer.vue?vue&type=script&lang=js&"
import style0 from "./StoreCustomer.vue?vue&type=style&index=0&id=a05d2d1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05d2d1c",
  null
  
)

export default component.exports